import React from "react"
import { Box, Typography, Button, Stack } from "@mui/material"
import PropTypes from "prop-types"
import emptyImage from "assets/images/empty.svg"

const EmptyState = ({
  title,
  buttonText,
  onButtonClick,
  secondaryButtonText,
  onSecondaryButtonClick,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
        textAlign: "center",
      }}
    >
      <img
        src={emptyImage}
        alt={title}
        aria-hidden="true"
        style={{
          height: "104px",
          maxWidth: "200px",
          marginBottom: "24px",
          pointerEvents: "none",
        }}
      />
      <Typography
        variant="h5"
        component="h3"
        sx={{ fontWeight: 600, marginBottom: "24px", color: "#414141" }}
      >
        {title}
      </Typography>
      <Stack direction="row" spacing={2} justifyContent="center">
        <Button
          variant="contained"
          color="branded"
          size="large"
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
        {secondaryButtonText && (
          <Button
            variant="outlined"
            color="branded"
            size="large"
            onClick={onSecondaryButtonClick}
          >
            {secondaryButtonText}
          </Button>
        )}
      </Stack>
    </Box>
  )
}

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
  secondaryButtonText: PropTypes.string,
  onSecondaryButtonClick: PropTypes.func,
}

export default EmptyState
